import type { ClipboardPayload } from '@model-framework/clipboard';
import type { ViewCollection } from '@view-model/domain/view/ViewCollection';
import type { ModelContentsCollection } from '@view-model/domain/model/model-contents/ModelContentsCollection';
import type { StickyModelContentsJSON } from '@view-model/domain/model/model-contents/StickyModelContents';
import type { ViewJSON, ViewModelId } from 'balus-common';
import type { PositionSet, PositionSetJSON } from '@view-model/models/common/PositionSet';
import { nanoid } from 'nanoid';
import type {
  ConsistencyLinkCollection,
  ConsistencyLinkCollectionJSON,
} from '@view-model/domain/ConsistencyLink/ConsistencyLinkCollection';

export type ViewsClipboardPayload = ClipboardPayload & {
  id: string;
  target: 'ViewModel';
  contentType: 'Views';
  sourceViewModelId: ViewModelId; // コピー元のビューモデルID
  views: ViewJSON[];
  viewPositions: PositionSetJSON;
  modelContents: StickyModelContentsJSON[];
  consistencyLinks: ConsistencyLinkCollectionJSON;
};

export namespace ViewsClipboardPayload {
  export function fromViewsAndModelContents(args: {
    sourceViewModelId: ViewModelId;
    views: ViewCollection;
    viewPositions: PositionSet;
    modelContents: ModelContentsCollection;
    consistencyLinks?: ConsistencyLinkCollection | null;
  }): ViewsClipboardPayload {
    const { sourceViewModelId, views, viewPositions, modelContents, consistencyLinks } = args;
    return {
      id: `${nanoid()}`,
      target: 'ViewModel',
      contentType: 'Views',
      sourceViewModelId,
      views: views.dumpWithUnlock(),
      viewPositions: viewPositions.dump(),
      modelContents: modelContents.dump(),
      consistencyLinks: consistencyLinks ? consistencyLinks.dump() : {},
    };
  }
}

export const isViewsClipboardPayload = (payload: ClipboardPayload): payload is ViewsClipboardPayload =>
  payload.target === 'ViewModel' && payload.contentType === 'Views';
